import { MetadataTable } from '@bechtel/sr-types';
import { createContext, FC, PropsWithChildren, useContext, useEffect } from 'react';
import { useAppUser } from '~/components';
import { useTableMetadataQuery } from '~/hooks';

export const TableMetadataContextPrivate = createContext<MetadataTable | null>(null);

export const useTableMetadataContext = () => {
  return useContext(TableMetadataContextPrivate);
};

interface TableMetadataContextProps {
  metadataTableName: string;
  tableMetaData?: { tableMetadata: MetadataTable } | null | undefined;
}

export const TableMetadataContext: FC<PropsWithChildren<TableMetadataContextProps>> = ({
  children,
  metadataTableName,
  tableMetaData,
}) => {
  const appUser = useAppUser();
  const [getTableMetaData, { data }] = useTableMetadataQuery();

  useEffect(() => {
    if (!appUser.userAccount?.defaultProject?.id || tableMetaData) return;
    getTableMetaData({
      variables: {
        name: metadataTableName,
        projectId: appUser.userAccount?.defaultProject?.id,
      },
    });
  }, [metadataTableName, appUser.userAccount?.defaultProject?.id, getTableMetaData, tableMetaData]);

  return (
    <TableMetadataContextPrivate.Provider value={tableMetaData ? tableMetaData.tableMetadata : data?.tableMetadata}>
      {children}
    </TableMetadataContextPrivate.Provider>
  );
};
